module.exports = __webpack_public_path__ + "8f3726ef2a0ff1755d5536da17ec3321.svg";